<!-- Modal de Advertencia de Sesión -->
<div 
  *ngIf="state.isVisible" 
  class="fixed inset-0 z-50 overflow-y-auto"
  (keydown)="onKeyDown($event)"
  role="dialog"
  aria-modal="true"
  aria-labelledby="session-warning-title"
  aria-describedby="session-warning-description">
  
  <!-- Backdrop -->
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div 
      class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"
      aria-hidden="true"
      (click)="onBackdropClick($event)">
    </div>

    <!-- Spacer element to center modal -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <!-- Modal Container -->
    <div class="inline-block align-bottom bg-white rounded-2xl px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
      
      <!-- Header con Icono de Advertencia -->
      <div class="sm:flex sm:items-start">
        <div class="mx-auto flex-shrink-0 flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 sm:mx-0 sm:h-12 sm:w-12 mb-4 sm:mb-0">
          <svg 
            class="h-8 w-8 sm:h-6 sm:w-6"
            [ngClass]="warningIconClass"
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke-width="2" 
            stroke="currentColor"
            aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.072 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        
        <!-- Contenido Principal -->
        <div class="mt-0 sm:mt-0 sm:ml-4 text-center sm:text-left flex-1">
          <!-- Título -->
          <h3 
            id="session-warning-title"
            class="text-xl font-bold text-gray-900 mb-2">
            ⏰ Su sesión está por expirar
          </h3>
          
          <!-- Descripción -->
          <div 
            id="session-warning-description"
            class="mt-2 text-sm text-gray-600 space-y-2">
            <p>{{ warningData?.message || 'Su sesión expirará pronto por inactividad.' }}</p>
            <p class="font-medium text-gray-800">
              ¿Desea continuar con su sesión?
            </p>
          </div>

          <!-- Contador y Barra de Progreso -->
          <div class="mt-6 space-y-4">
            <!-- Tiempo Restante -->
            <div class="text-center">
              <div class="text-3xl font-bold text-gray-900 mb-2">
                {{ formattedTimeRemaining }}
              </div>
              <div class="text-sm text-gray-500">
                Tiempo restante
              </div>
            </div>

            <!-- Barra de Progreso -->
            <div class="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
              <div 
                class="h-3 transition-all duration-1000 ease-linear rounded-full"
                [ngClass]="progressColorClass"
                [style.width.%]="progressPercentage">
              </div>
            </div>

            <!-- Indicador de Estado -->
            <div class="text-center text-xs text-gray-500" *ngIf="state.countdown > 0">
              La sesión se cerrará automáticamente cuando llegue a 0
            </div>
          </div>

          <!-- Estado de Extensión -->
          <div *ngIf="state.hasExtended" class="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
            <div class="flex items-center">
              <svg class="h-5 w-5 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span class="text-sm font-medium text-green-800">
                ¡Sesión extendida exitosamente!
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Botones de Acción -->
      <div class="mt-6 sm:mt-8 sm:flex sm:flex-row-reverse space-y-3 sm:space-y-0 sm:space-x-reverse sm:space-x-3">
        
        <!-- Botón Continuar Sesión -->
        <button
          type="button"
          (click)="onExtendSession()"
          [disabled]="!state.canExtend || state.isExtending || state.hasExtended"
          class="w-full inline-flex justify-center items-center rounded-xl border border-transparent shadow-sm px-6 py-3 text-base font-medium text-white transition-all duration-200 sm:ml-3 sm:w-auto sm:text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
          [ngClass]="{
            'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500': state.canExtend && !state.isExtending && !state.hasExtended,
            'bg-green-600': state.hasExtended,
            'bg-gray-400': !state.canExtend || state.isExtending
          }">
          
          <!-- Spinner de carga -->
          <svg 
            *ngIf="state.isExtending" 
            class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" 
            xmlns="http://www.w3.org/2000/svg" 
            fill="none" 
            viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>

          <!-- Icono de éxito -->
          <svg 
            *ngIf="state.hasExtended" 
            class="h-4 w-4 mr-2" 
            fill="currentColor" 
            viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
          </svg>

          <span>
            {{ state.isExtending ? 'Extendiendo...' : (state.hasExtended ? '¡Extendida!' : 'Continuar Sesión') }}
          </span>
        </button>

        <!-- Botón Cerrar Sesión -->
        <button
          type="button"
          (click)="onLogout()"
          [disabled]="state.isExtending"
          class="mt-3 w-full inline-flex justify-center items-center rounded-xl border border-gray-300 shadow-sm px-6 py-3 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:w-auto sm:text-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
          
          <svg class="h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          
          Cerrar Sesión
        </button>
      </div>

      <!-- Información Adicional -->
      <div class="mt-6 pt-4 border-t border-gray-200">
        <div class="flex items-center text-xs text-gray-500">
          <svg class="h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>
            Su sesión se cerró por inactividad para proteger su información.
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
